import * as React from "react";
import { connect } from "react-redux";
import { CoopInfo } from "./info-view/CoopInfo";
import { CoopMember } from "./info-view/CoopMember";
var TabCoopInfoViewDOM = function (_a) {
    var coop = _a.coop;
    if (!coop) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "w100 h100 flex flex--stacked flex--aligned flex--spaced flex--around" },
        React.createElement(CoopInfo, null),
        React.createElement(CoopMember, null)));
};
var mapState = function (state) { return ({
    coop: state.coopInfo.coop,
}); };
export var TabCoopInfoView = connect(mapState)(TabCoopInfoViewDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/TabCoopInfoView.tsx
// module id = 2606
// module chunks = 3